import React, {memo} from 'react'
import {useWatch} from 'react-hook-form'

import {AddressWidgetConfig} from '../../../types'
import {useAddressWidget} from '../../hooks/useAddressWidget'
import {useSelectionDependentComponents} from '../../hooks/useSelectionDependentComponents'
import {AddressDrawer} from '../AddressDrawer'
import {AddressPointSlot} from '../AddressPointSlot/AddressPointSlot'
import {AddressDetails} from '../Details/Address'
import {ContactDetails} from '../Details/Contact'
import {usePrefetchAddress} from './hooks/usePrefetchAddress'

/**
 * Компонент ввода адреса с дровером, в котором форма с адресом и данными контактного лица.
 */
export const AddressWidget = memo((props: AddressWidgetConfig): React.ReactElement => {
  const isSource = props.route_point_index === 0 // если это первая точка в пути, то это точка отправления ("Откуда")
  const addressName = `route.${isSource ? 'source' : `destination_${props.route_point_index}`}.address`
  const contactsName = `contacts.${props.route_point_index}`

  usePrefetchAddress(addressName, isSource)

  const address = useWatch({name: addressName})

  const {handleClose, handleOpen, handleSubmit, isFinalRoutePoint, opened} = useAddressWidget(
    addressName,
    contactsName,
    props,
  )
  const {headerTitle} = useSelectionDependentComponents(Boolean(address), props)

  return (
    <>
      <AddressPointSlot addressWidgetConfig={props} name={addressName} onClick={handleOpen} />
      <AddressDrawer
        isFinalRoutePoint={isFinalRoutePoint}
        onClose={handleClose}
        onSubmit={handleSubmit}
        opened={opened}
        title={headerTitle}
      >
        <AddressDetails addressWidgetConfig={props} name={addressName} />
        <ContactDetails name={contactsName} routePointIndex={props.route_point_index} />
      </AddressDrawer>
    </>
  )
})
